import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDateRangeModal } from './useDateRangeModal';
import ModalSystem from '../../DesignSystem/ModalSystem';
import RangePickerSystem from '../../DesignSystem/RangePickerSystem';
import ButtonSystem from '../../DesignSystem/ButtonSystem';
import { CalendarIcon } from '../../../icons';
import { Colors } from '../../../constants/colors.constants';
import './DateRangeModal.scss';

const MODAL_WIDTH = 380;
const THEME_DARK = 'dark';
const { PRIMARY } = Colors;

const DateRangeModal = ({
  isDateRangeModalVisible,
  setIsDateRangeModalVisible
}) => {
  const { t } = useTranslation();

  const {
    datesSelected,
    handleDateSelection,
    handleCloseDateRangeModal,
    handleApplyDateRange
  } = useDateRangeModal(setIsDateRangeModalVisible);

  return (
    <ModalSystem
      visible={isDateRangeModalVisible}
      setVisible={handleCloseDateRangeModal}
      theme={THEME_DARK}
      showTitle
      title={t('lookahead_visualizationOpt.time_frame_filter_date')}
      width={MODAL_WIDTH}
      showIconTitle
      iconTitle={<CalendarIcon color={PRIMARY} />}
      centered>
      <div className="date-range-modal">
        <RangePickerSystem
          onTop
          theme={THEME_DARK}
          value={datesSelected}
          onChange={handleDateSelection}
        />

        <div className="date-range-modal__buttons">
          <ButtonSystem type="secondary" onClick={handleCloseDateRangeModal}>
            {t(
              'lookahead_visualizationOpt.time_frame_filter_date_range_cancel'
            )}
          </ButtonSystem>
          <ButtonSystem
            type="primary"
            disabled={datesSelected.length === 0}
            onClick={handleApplyDateRange}>
            {t('lookahead_visualizationOpt.time_frame_filter_date_range_apply')}
          </ButtonSystem>
        </div>
      </div>
    </ModalSystem>
  );
};

DateRangeModal.propTypes = {
  isDateRangeModalVisible: PropTypes.bool,
  setIsDateRangeModalVisible: PropTypes.func
};

export default DateRangeModal;
